export const ENVIRONMENT_HEADER = 'x-mapp-environment';
const getNodeEnvValue = (key) => {
    if (typeof process === 'undefined' || !process.env) {
        return undefined;
    }
    return process.env[key];
};
const configs = {
    local: {
        APP_MAPP_ID: 'store-admin-local',
        APP_MAPP_AUTH_URL: 'https://dev.admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://dev.api.superapp.yum.com',
        API_BASE_URL: 'http://localhost:3001/api',
        API_TIMEOUT: 30000,
        ENABLE_LOGGING: true,
        BYTE_GRAPH_URL: getNodeEnvValue('BYTE_GRAPH_URL') || 'https://api.staging.yumconnect.dev/ph_us/business/graphql',
    },
    dev: {
        APP_MAPP_ID: 'byte-store-control-dev',
        APP_MAPP_AUTH_URL: 'https://dev.admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://dev.api.superapp.yum.com',
        API_BASE_URL: '/api', // Use same-origin routing through CloudFront
        API_TIMEOUT: 30000,
        ENABLE_LOGGING: true,
        BYTE_GRAPH_URL: getNodeEnvValue('BYTE_GRAPH_URL') || 'https://api.staging.yumconnect.dev/tb_uk/business/graphql',
    },
    staging: {
        APP_MAPP_ID: 'byte-store-control-staging',
        APP_MAPP_AUTH_URL: 'https://staging.admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://staging.api.superapp.yum.com',
        API_BASE_URL: '/api', // Use same-origin routing through CloudFront
        API_TIMEOUT: 30000,
        ENABLE_LOGGING: true,
        BYTE_GRAPH_URL: getNodeEnvValue('BYTE_GRAPH_URL') || 'https://api.staging.yumconnect.dev/ph_us/business/graphql',
    },
    production: {
        APP_MAPP_ID: 'byte-store-control',
        APP_MAPP_AUTH_URL: 'https://admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://api.superapp.yum.com',
        API_BASE_URL: '/api', // Use same-origin routing through CloudFront
        API_TIMEOUT: 30000,
        ENABLE_LOGGING: false,
        BYTE_GRAPH_URL: getNodeEnvValue('BYTE_GRAPH_URL') || 'https://api.prod.hopper.yumconnect.dev/phdv_prod/business/graphql',
    },
};
export function getEnvironmentConfig(env) {
    const environment = (env || getNodeEnvValue('NODE_ENV') || 'local');
    return configs[environment] || configs.local;
}
export const currentEnvironment = (getNodeEnvValue('NODE_ENV') || 'local');
export const environmentConfig = getEnvironmentConfig(currentEnvironment);
// Export org mapping utilities
export * from './org-mapping';
